import { createReducer, on, Action } from '@ngrx/store'

import * as SelectedProfileActions from './selected-profile.actions'
import { ProfileEntity } from './selected-profile.models'
import { FrontState } from 'libs/gb-front/core/data-access/src'

export const SELECTED_PROFILE_FEATURE_KEY = 'selectedProfile'

export interface SelectedProfileState extends ProfileEntity {
  loaded: boolean // has the SelectedProfile been loaded
}

export const initialState: SelectedProfileState = {
  uuid: '',
  loaded: false,
}

// lazy load state
export interface State extends FrontState {
  [SELECTED_PROFILE_FEATURE_KEY]: SelectedProfileState
}

export const selectedProfileReducer = createReducer(
  initialState,
  on(SelectedProfileActions.updateSelectedProfileSuccess, (state, { profile }) => ({
    ...profile,
    error: null,
    loaded: true,
  })),
  on(SelectedProfileActions.syncProfile, (state) => ({
    ...state,
    loaded: false,
  })),
  on(SelectedProfileActions.syncProfileSuccess, (state, { profile }) => ({
    ...profile,
    error: null,
    loaded: true,
  })),
  on(SelectedProfileActions.syncProfileFailure, (state, { error }) => ({
    ...state,
    loaded: true,
  })),
  on(SelectedProfileActions.setSelectedProfile, (state, { uuid }) => ({
    ...initialState,
    uuid,
  })),
  on(SelectedProfileActions.setGuestProfile, (state, { profile }) => ({
    ...profile,
    error: null,
    loaded: true,
  })),
  on(SelectedProfileActions.clearSelectedProfile, (state) => ({
    ...initialState,
  })),
  on(SelectedProfileActions.createCustomValueSuccess, (state, action) => ({
    ...state,
    custom_registration_values: [...(state.custom_registration_values || []), action.customValue],
  })),
)

export function reducer(state: SelectedProfileState | undefined, action: Action) {
  return selectedProfileReducer(state, action)
}
